module.exports = __webpack_public_path__ + "static/media/1.fee29e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/tmsAbout/img/1.png
// module id = 435
// module chunks = 0